import React, { useCallback } from 'react';
import { format } from 'date-fns';
import Text from 'design-system/Text';
import { muteAll, useFetchOld } from 'hooks';
import { goBackToTopWithStops } from 'utils/navigationv6';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import { editSavingsPlan } from '../actions';
import { getPeriodFromRRule } from '../utils';
const fetchOptions = {
    ...muteAll,
    throws: true,
    muteFetching: false,
};
export const useUpdateAutosaveCollectionFrequency = (skipSuccessScreen) => {
    const navigation = useMainStackNavigation();
    const [, , fetching, fetch] = useFetchOld(fetchOptions);
    const updateCollectionFrequency = useCallback(async (autosaveId, rrule, savingRules) => {
        try {
            const result = await fetch(editSavingsPlan(autosaveId, {
                collectionFrequency: {
                    rrule,
                },
                rules: savingRules,
            }));
            if (result) {
                if (!skipSuccessScreen) {
                    const savingsPlanObj = result.savingsPlan;
                    const period = getPeriodFromRRule(rrule).toLowerCase();
                    navigation.navigate('Success', {
                        title: 'Success',
                        subTitle: (<Text TextThin-16 Secondary>
                  Your first collection is scheduled for
                  <Text Text-16 Secondary>
                    {' '}
                    {format(savingsPlanObj.nextPaymentCollectionDate, 'EEEE, d MMMM yyyy')}{' '}
                  </Text>
                  and will repeat {period}. We’ll handle it from here and give you a heads-up before each payment.
                </Text>),
                        onContinue: () => {
                            goBackToTopWithStops(navigation, ['AutoSave']);
                            return true;
                        },
                        buttonText: 'Done',
                    });
                }
                else {
                    goBackToTopWithStops(navigation, ['AutoSave']);
                }
            }
        }
        catch {
            //
        }
    }, [skipSuccessScreen]);
    return { updateCollectionFrequency, fetching };
};
